import Modal from '../../atoms/Modal';
import StateView from '../../atoms/State';
import { BaseModalData } from '../../types/Modals';
import { MeetingId } from '../../types/Types';
import { MeetingPageView } from './index';
import { useCallback } from 'react';
import { useDataSubscribion } from '../../hooks/useDataSubscribion';
import { useTranslation } from 'react-i18next';

export interface MeetingModalData extends BaseModalData {
    id: MeetingId;
}

export function MeetingModal(props: {
    onClose: () => void;
    data: MeetingModalData;
    index: number;
    onFocus: VoidFunction;
}) {
    const { t } = useTranslation();
    const { state, revalidate } = useDataSubscribion(
        useCallback(
            (x) => x.subscribeForMeetingWithMessagesAndAttachments(props.data.id, true),
            [props.data.id]
        )
    );
    return (
        <Modal
            index={props.index}
            onFocus={props.onFocus}
            onClose={props.onClose}
            height={props.data.height ?? 800}
            width={props.data.width}
            title={
                props.data.title ??
                (state.type === 'done' && state.data.meeting && state.data.meeting.title
                    ? t('modal.meeting.titleWithName', { name: state.data.meeting.title })
                    : t('modal.meeting.titleWithoutName'))
            }>
            <StateView state={state} retry={revalidate}>
                {(data) => (
                    <MeetingPageView
                        meeting={data.meeting}
                        meetingMessageDraft={data.meetingMessageDraft}
                        messages={data.messages}
                        hasAccess={data.hasAccessToThreadContent}
                        attachments={data.attachments}
                    />
                )}
            </StateView>
        </Modal>
    );
}
